/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, TableCell, TableRow, Text, VFlow } from 'bold-ui'
import { DateTime } from 'components/date'
import { TipoParteBucalEnum } from 'graphql/types.generated'
import { Fragment, useMemo } from 'react'
import { titleCase } from 'util/strConversor'

import { EvolucoesOdontoRowItem } from './EvolucoesOdontoTable'

interface EvolucoesOdontoTableRowProps {
  evolucaoOdonto: EvolucoesOdontoRowItem
}

export function EvolucoesOdontoTableRow(props: EvolucoesOdontoTableRowProps) {
  const { evolucaoOdonto } = props
  const classes = useMemo(() => createStyles(!!evolucaoOdonto.observacao), [evolucaoOdonto.observacao])

  const renderLocalEvolucao = (local: EvolucoesOdontoRowItem) => {
    return local.partesBucais?.length ? (
      local.partesBucais.map((parte, key) => (
        <Text key={key}>
          {parte?.tipoParteBucal === TipoParteBucalEnum.SUPRANUMERARIO ? local.descricaoParteBucal : parte.descricao}
          <br />
        </Text>
      ))
    ) : (
      <Text>
        {local.descricaoParteBucal}
        <br />
      </Text>
    )
  }

  const renderProcedimento = (procedimentos: EvolucoesOdontoRowItem) => {
    return procedimentos?.procedimentos?.map((proced) => (
      <Text key={proced.id}>
        {proced.descricao} - {proced.codigo}
        <br />
      </Text>
    ))
  }

  return (
    <Fragment>
      <TableRow>
        <TableCell style={classes.column}>
          <DateTime
            value={evolucaoOdonto.atendimentoProfissionalOdonto.atendimentoProfissional.iniciadoEm}
            format='DD/MM/YYYY'
          />
        </TableCell>
        <TableCell style={classes.localEvolucao}>{renderLocalEvolucao(evolucaoOdonto)}</TableCell>
        <TableCell style={classes.column}>{renderProcedimento(evolucaoOdonto)}</TableCell>
        <TableCell style={classes.column}>
          <VFlow vSpacing={0}>
            {titleCase(evolucaoOdonto.atendimentoProfissionalOdonto.atendimentoProfissional.lotacao.profissional.nome)}
            {evolucaoOdonto.atendimentoProfissionalOdonto.atendimentoProfissional.lotacao.cbo.nome}
          </VFlow>
        </TableCell>
      </TableRow>
      {evolucaoOdonto.observacao && (
        <TableRow>
          <TableCell
            colSpan={4}
            style={css`
              height: auto;
              border-top: 0;
              padding-bottom: 0.375rem;
            `}
          >
            <HFlow hSpacing={0.2}>
              <Text fontWeight='bold'>Observações: </Text>
              <Text
                fontStyle='italic'
                style={css`
                  word-break: break-all;
                `}
              >
                <div dangerouslySetInnerHTML={{ __html: evolucaoOdonto.observacao }} />
              </Text>
            </HFlow>
          </TableCell>
        </TableRow>
      )}
    </Fragment>
  )
}

const createStyles = (removeBorderBottom?: boolean) => ({
  localEvolucao: css`
    padding: 0.375rem 1rem;
    max-width: 33rem;
    ${removeBorderBottom && `border-bottom: 0;`}
  `,
  column: css`
    padding: 0.375rem 1rem;
    ${removeBorderBottom && `border-bottom: 0;`}
  `,
})
